import React from 'react';
import PropTypes from 'prop-types';
import { styles } from '4all-ui/styles';

const DeliveryIcon = ({ size, color, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={`delivery-icon ${className}`}
  >
    <defs>
      <path
        d="M21,9.71922359 L23.7574644,9.0298575 C24.3886111,8.87207082 25,9.34942885 25,10 L25,15 C25,15.6505712 24.3886111,16.1279292 23.7574644,15.9701425 L21,15.2807764 L21,17.0313006 C25.9712565,17.3474664 29,20.0143164 29,23 C29,23.5522847 28.5522847,24 28,24 L26,24 C26,25.9322847 24.4322847,27.5 22.5,27.5 C20.5677153,27.5 19,25.9322847 19,24 L13,24 C12.4477153,24 12,23.5522847 12,23 C12,22.9007697 11.9831754,22.6866386 11.9304559,22.3990779 C11.8412202,21.9123373 11.681029,21.4269095 11.4362841,20.9819187 C10.7583043,19.7492282 9.56420169,19.0164009 7.56758904,19.0002719 L7.43241096,19.0002719 C5.43579831,19.0164009 4.2416957,19.7492282 3.56371591,20.9819187 C3.31897101,21.4269095 3.15877983,21.9123373 3.06954406,22.3990779 C3.01682458,22.6866386 3,22.9007697 3,23 C3,23.5522847 2.55228475,24 2,24 C1.44771525,24 1,23.5522847 1,23 C1,22.2215767 1.2003192,21.1289265 1.81128409,20.0180813 C2.75053042,18.3103607 4.38997832,17.2132743 6.76539425,17.027945 C6.84064174,17.0098544 6.91920181,17.0002719 7,17.0002719 L7.40706508,17.0004285 C7.43793112,17.000143 7.46890941,17 7.5,17 C7.53368616,17 7.56724047,17.0001679 7.60066303,17.000503 L11.9406395,17.0021727 C11.9641862,17.0007788 11.9641862,17.0007788 12.0258721,16.9983857 C12.3103851,16.9890145 12.6676792,16.9989225 13.0736051,17.0422988 C13.6786463,17.1069522 14.2784054,17.2355277 14.8495175,17.4462218 C16.7813402,18.1589078 18.0045345,19.6637391 18.0045345,22 L19,22 L19,10 L18,10 C17.4477153,10 17,9.55228475 17,9 C17,8.44771525 17.4477153,8 18,8 L20,8 C20.5522847,8 21,8.44771525 21,9 L21,9.71922359 Z M21,11.7807764 L21,13.2192236 L23,13.7192236 L23,11.2807764 L21,11.7807764 Z M16.0045345,22 C16.0045345,20.5662414 15.3518785,19.7633133 14.1572842,19.3226048 C13.593527,19.1146241 12.9966917,19.0199981 12.4809809,18.9991347 C12.7498619,19.308213 12.9856531,19.6488762 13.1887159,20.0180813 C13.5690367,20.7095736 13.7902338,21.3940155 13.9030407,22 L16.0045345,22 Z M21,22 L26.7894565,22 C26.1677003,20.5411451 24.1815501,19.2574223 21,19.0342522 L21,22 Z M9,24 C9,23.1722847 8.32771525,22.5 7.5,22.5 C6.67228475,22.5 6,23.1722847 6,24 C6,24.8277153 6.67228475,25.5 7.5,25.5 C8.32771525,25.5 9,24.8277153 9,24 Z M11,24 C11,25.9322847 9.43228475,27.5 7.5,27.5 C5.56771525,27.5 4,25.9322847 4,24 C4,22.0677153 5.56771525,20.5 7.5,20.5 C9.43228475,20.5 11,22.0677153 11,24 Z M22.5,25.5 C23.3241984,25.5 23.9942843,24.833416 23.9999636,24.0105421 C23.6183195,24.0118708 23.1432382,24.0128911 22.5907026,24.0136387 C22.1169554,24.0142796 21.6110581,24.0146838 21.0940006,24.0148995 C21.0619718,24.0149128 21.030697,24.0149253 21.000073,24.0149368 C21.0081028,24.8357881 21.6772694,25.5 22.5,25.5 Z M5,15.9974976 C4.44771525,15.9974976 4,15.5497823 4,14.9974976 L4,8 C4,7.44771525 4.44771525,7 5,7 L12,7 C12.5522847,7 13,7.44771525 13,8 L13,14.9974976 C13,15.5497823 12.5522847,15.9974976 12,15.9974976 L5,15.9974976 Z M11,13.9974976 L11,9 L6,9 L6,13.9974976 L11,13.9974976 Z"
        id="delivery-path-1"
      />
    </defs>
    <g id="Library-" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon/delivery/">
        <mask id="delivery-mask-2" fill="white">
          <use xlinkHref="#delivery-path-1" />
        </mask>
        <use id="delivery" fill="#FFF" fillRule="nonzero" xlinkHref="#delivery-path-1" />
        <g id="colors/portal_único/grey3" mask="url(#delivery-mask-2)" fill={color}>
          <rect id="color" x="0" y="0" width="30" height="30" />
        </g>
      </g>
    </g>
  </svg>
);

DeliveryIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
};

DeliveryIcon.defaultProps = {
  color: styles.colors.GRAY_DARKER,
  size: '30px',
  className: '',
};

export default DeliveryIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Delivery/index.js